// Importing Foundation first
// ### Core
import $ from 'jquery';
import './global/foundation';
import 'what-input';

// Load foundation with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadFoundation = {
    attach: function (context, settings) {
      $(context).foundation();
    },
  };
})(jQuery, Drupal);

// Import all your components here
// But don't code inside this file.
// import './utils/polyfills'; // Only if supporting IE & Edge 15
import './utils/videos';
import './utils/tables';
import './utils/youtubeIframe';

// Components
import './components/abonnement';
import './components/fixedHeader';
import './components/inViewport';
import './components/lazyLoad';
import './components/mobileMenu';
import './components/smoothScroll';
import './components/swiper';
import './components/searchBar';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}

